<template>
  <FlexCardListPrimary
    v-bind="$attrs"
    v-on="$listeners"
    :divisor="12"
    :elementLength="surveys.length + 1"
  >
    <template v-slot:element="props">
      <CardCreateSurvey
        v-if="props.index === 0"
        v-on="$listeners"
      />
      <CardSurvey
        v-else
        v-on="$listeners"
        :survey="surveys[props.index - 1]"
      />
    </template>
  </FlexCardListPrimary>
</template>

<script>
  import CardCreateSurvey from '@survey/modules/card-create-survey'
  import CardSurvey from '@survey/modules/card-survey'
  import FlexCardListPrimary from '@modules/v2/flex-list/flex-card-list-primary'

  export default {
    name: 'AdminSurveyList',
    inheritAttrs: false,
    components: {
      CardCreateSurvey,
      CardSurvey,
      FlexCardListPrimary,
    },
    props: {
      surveys: {
        type: Array,
        required: false,
        default: () => [],
      },
    },
  };
</script>
